<template>
  <div id="app">
    <b-alert :show="restaurantFetched && isRestaurantClosed" fade variant="danger" class="m-0">
      Our restaurant is closed right now. We will resume operations at {{ $moment(currentRestaurant.opening_time, 'HHmm').format('LT') }}
    </b-alert>

    <div :class="{ 'disable-app': isRestaurantClosed }">
      <notifications position="top center" width="40%"/>
      <app-navbar></app-navbar>
      <router-view/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Navbar from './components/navbar.vue'

export default {
  name: 'App',

  components: {
    'app-navbar': Navbar
  },

  created() {
    this.$store.dispatch('getRestaurant')
  },

  computed: {
    ...mapGetters(['currentRestaurant']),
    restaurantFetched() {
      if (this.currentRestaurant != null)
        return true
      return false
    },
    isRestaurantClosed() {
      let current_time = this.$moment().format('HHMM')
      if (this.currentRestaurant.opening_time < current_time && current_time < this.currentRestaurant.closing_time)
        return false
      return true
    }
  },
}
</script>

<style>
  #app{
    font-family: "Josefin Sans";
  }
  .title {
    padding-top: 20px;
  }
  .vue-notification-group {
    margin-top: 2.5vh;
  }
  .notification-content {
    font-size: 14px;
  }
  .login-image {
    background-image: url('./assets/images/login.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .signup-image {
    background-image: url('./assets/images/sign_up.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .loader {
    position: fixed;
    top: 48%;
    left: 48%;
  }
  .loader .text-primary {
    color: #7f86ff !important;
  }
  .font-lighter {
    font-weight: lighter;
  }
  .text-purple {
    color: #5663FF;
  }
  .disable-app {
    pointer-events: none;
    height: 100%;
    width: 100%;
    opacity: 0.5;
  }
  .alert {
    height: auto;
  }
  .desc-note {
    font-size: small;
    color: #495057;
    font-style: italic;
  }
</style>
